import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material';

const styles = makeStyles(() => ({
	Box: {
		width: '100%',
		// marginTop: useTheme().spacing(2),
		// marginBottom: useTheme().spacing(12),
	},
	containerRoot: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
	},
	[useTheme().breakpoints.down('sm')]: {
		headingText: {
			paddingTop: useTheme().spacing(4),
			paddingBottom: useTheme().spacing(4),
		},
	},
	[useTheme().breakpoints.up('md')]: {
		headingText: {
			paddingTop: useTheme().spacing(8),
			paddingBottom: useTheme().spacing(8),
		},
	},
	GridContainer: {
		paddingLeft: useTheme().spacing(2),
		paddingRight: useTheme().spacing(2),
		gap: 16,
	},
}));

export default styles;
